var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 180,
    viewBox: "0 0 288 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1613_30273)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1613_30273)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.96 182.097C66.2721 176.772 86.1745 158.056 108.219 143.636C140.074 122.798 165.791 133.171 180.077 145.956C196.047 160.247 234.87 180.145 260.352 182.017C262.354 182.043 264.37 182.07 266.4 182.097C264.49 182.204 262.467 182.172 260.352 182.017C138.887 180.417 69.1706 180.047 48.96 182.097Z",
    fill: "url(#paint0_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.78 63.4792C214.78 63.4792 208.012 10.5192 168.08 48.5951C116.89 97.4027 82.4809 0.396462 44.5068 39.9934C23.7608 61.6251 78.5819 110.004 41.9691 135.464C5.35639 160.924 35.2756 179.984 35.2756 179.984H243.172C243.172 179.984 264.694 181.538 266.323 154.305C267.95 127.072 242.932 126.742 258.459 92.6624C273.986 58.5828 219.659 85.1708 214.78 63.4792Z",
    fill: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.726 80.8447C119.726 84.1572 117.047 86.836 113.706 86.836C113.648 86.836 113.159 86.836 109.558 86.836C107.052 86.836 103.048 86.836 96.6537 86.836H93.6005C89.5967 86.9224 86.3994 83.7251 86.3994 79.8654C86.3994 75.9768 89.6255 72.7507 93.6869 72.9523C97.1722 62.0643 113.13 63.591 114.484 74.8534C117.479 75.2279 119.726 77.7626 119.726 80.8447Z",
    fill: "url(#paint1_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.707 86.8361C117.019 86.8361 119.727 84.1573 119.727 80.8448C119.727 77.5323 117.019 74.8535 113.707 74.8535C110.394 74.8535 107.687 77.5323 107.687 80.8448C107.687 84.1573 110.394 86.8361 113.707 86.8361Z",
    fill: "url(#paint2_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.884 86.8933C109.789 86.8933 114.599 82.1118 114.599 76.2069C114.599 70.302 109.789 65.5205 103.884 65.5205C97.9793 65.5205 93.1689 70.302 93.1689 76.2069C93.1689 82.1118 97.9505 86.8933 103.884 86.8933Z",
    fill: "url(#paint3_linear_1613_30273)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1613_30273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.726 88.3758C227.726 93.4774 223.6 97.603 218.454 97.603C218.366 97.603 217.611 97.603 212.066 97.603C208.207 97.603 202.041 97.603 192.192 97.603H187.49C181.324 97.7361 176.399 92.8119 176.399 86.8675C176.399 80.8786 181.368 75.9101 187.623 76.2207C192.991 59.4519 217.567 61.8031 219.652 79.1485C224.266 79.7252 227.726 83.6291 227.726 88.3758Z",
    fill: "url(#paint4_linear_1613_30273)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218.454 97.6029C223.556 97.6029 227.726 93.4773 227.726 88.3757C227.726 83.2741 223.556 79.1484 218.454 79.1484C213.353 79.1484 209.183 83.2741 209.183 88.3757C209.183 93.4773 213.353 97.6029 218.454 97.6029Z",
    fill: "url(#paint5_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.327 97.6918C212.421 97.6918 219.829 90.3278 219.829 81.2336C219.829 72.1394 212.421 64.7754 203.327 64.7754C194.233 64.7754 186.824 72.1394 186.824 81.2336C186.824 90.3278 194.188 97.6918 203.327 97.6918Z",
    fill: "url(#paint6_linear_1613_30273)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M98.6396 182.121C110.277 178.074 129.904 169.854 144.722 158.894C166.134 143.056 168.927 146.224 182.891 154.142C195.996 161.574 224.269 180.628 241.55 182.073C242.627 182.089 243.71 182.105 244.8 182.121C243.768 182.186 242.683 182.167 241.55 182.073C159.399 180.847 112.27 180.558 98.6396 182.121Z",
    fill: "url(#paint7_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7998 182.126C76.4367 178.5 96.0638 171.136 110.882 161.318C132.294 147.13 135.087 149.968 149.051 157.061C162.156 163.719 190.43 180.788 207.71 182.082C208.787 182.097 209.87 182.111 210.96 182.126C209.929 182.184 208.843 182.167 207.71 182.082C125.56 180.984 78.4302 180.726 64.7998 182.126Z",
    fill: "url(#paint8_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.04 182.132C124.677 178.513 150.837 171.181 164.243 159.475C181 144.842 186.12 145.314 200.084 152.394C213.361 159.126 239.679 180.79 256.641 182.098C257.49 182.109 258.343 182.121 259.2 182.132C258.374 182.179 257.52 182.166 256.641 182.098C174.064 180.994 126.709 180.73 113.04 182.132Z",
    fill: "url(#paint9_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1167 121.129C66.1167 121.129 63.302 120.072 61.8964 125.344C60.4907 130.617 56.2704 129.576 55.2145 135.562C54.1586 141.548 55.5508 147.534 54.5117 150.348C53.4726 153.163 50.2914 157.755 52.7529 163.377C55.2145 169 60.8405 172.531 68.5783 170.417C76.3161 168.303 83.7109 169.01 84.7533 156.688C85.7958 144.366 75.6099 147.18 75.963 141.902C76.3161 136.623 81.5889 134.859 77.7217 129.93C73.8545 125.001 71.0398 126.408 69.2811 123.24C67.5224 120.072 66.1167 121.129 66.1167 121.129Z",
    fill: "#B3EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4305 181.075L67.2165 125.186H67.0282L65.418 181.182L67.4305 181.075Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8083 166.946L53.4365 157.748L66.5582 165.633L65.8083 166.946Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.753 149.248L57.5625 142.417L67.3113 148.272L66.753 149.248Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3099 160.377L79.6816 151.18L66.5566 159.061L67.3099 160.377Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4246 139.094L75.5558 133.051L66.9336 138.229L67.4246 139.094Z",
    fill: "#4D6173"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.931 75.2004C216.032 70.9232 203.99 62.9249 196.597 56.381C199.939 45.2784 213.291 40.0079 223.42 46.7358C233.479 53.4167 233.916 67.7439 224.931 75.2004Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.431 50.7393C184.846 42.0566 173.709 37.367 172.173 39.7323C170.59 42.1714 180.133 51.743 194.888 62.8319C219.235 81.2347 247.545 96.5253 250.088 92.6079C252.728 88.5426 225.867 66.408 199.431 50.7393Z",
    fill: "#FEA21E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M226.563 64.4419C227.898 64.1726 228.623 62.1861 228.183 60.0051C227.743 57.8241 226.304 56.2743 224.969 56.5436C223.635 56.8129 222.91 58.7993 223.35 60.9804C223.79 63.1614 225.228 64.7112 226.563 64.4419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M218.137 53.6901C219.211 53.4733 219.869 52.242 219.606 50.9399C219.343 49.6378 218.26 48.7579 217.185 48.9747C216.111 49.1915 215.453 50.4228 215.716 51.7249C215.979 53.027 217.063 53.9068 218.137 53.6901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M206.066 52.0517C207.03 51.6894 207.574 50.7658 207.282 49.9887C206.99 49.2116 205.972 48.8754 205.008 49.2376C204.045 49.5999 203.501 50.5235 203.793 51.3006C204.085 52.0777 205.103 52.4139 206.066 52.0517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M213.853 57.2781C215.407 56.6938 216.269 55.1618 215.779 53.8563C215.288 52.5508 213.63 51.9661 212.076 52.5504C210.522 53.1347 209.66 54.6667 210.15 55.9722C210.641 57.2777 212.299 57.8624 213.853 57.2781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M197.008 56.5794L75.6003 179.278L214.841 179.278L222.933 73.2735L197.008 56.5794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.966,
    cy: 64.9286,
    rx: 15.4214,
    ry: 2.87833,
    transform: "rotate(32.6776 209.966 64.9286)",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.264 126.665L151.144 132.361C147.509 131.317 144.521 124.428 144.521 124.428C150.127 126.667 153.034 122.723 153.034 122.723C153.042 125.383 158.264 126.665 158.264 126.665Z",
    fill: "url(#paint10_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.717 156.11L130.015 151.469C130.015 151.469 131.575 142.418 137.652 141.709L144.637 146.267C144.637 146.268 135.493 148.239 137.717 156.11Z",
    fill: "url(#paint11_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.906 110.776C128.925 112.739 127.732 120.388 127.732 120.388L123.942 119.013C123.414 113.045 128.152 109.291 128.152 109.291L132.906 110.776Z",
    fill: "url(#paint12_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.298 171.187C158.102 171.254 157.596 171.407 156.906 171.591C154.452 171.378 152.094 171.207 149.874 171.076C148.751 169.47 148.467 166.941 148.467 166.941L156.267 166.693C156.268 166.693 156.374 171.756 158.298 171.187Z",
    fill: "url(#paint13_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.117 72.1774L205.358 79.7237L199.513 76.7861L204.309 70.454L209.117 72.1774Z",
    fill: "url(#paint14_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.764 100.596C199.798 97.4382 198.138 92.3973 198.138 92.3973L204.38 91.6073C205.239 94.1031 204.853 99.7407 204.853 99.7407L197.764 100.596ZM189.215 106.915C189.215 106.915 186.101 107.496 185.317 105.653C185.317 105.653 186.163 101.295 187.366 101.014L190.439 101.711C190.44 101.712 189.078 104.028 189.215 106.915ZM183.335 127.459C183.335 127.459 178.301 124.277 177.981 122.099C177.981 122.099 180.539 117.544 186.093 117.295L190.283 122.107C190.284 122.107 182.391 125.655 183.335 127.459ZM177.926 150.217C177.926 150.217 169.73 155.532 168.122 151.786C168.122 151.786 165.247 148.915 164.419 145.885C164.419 145.885 169.654 146.292 173.26 143.183C173.259 143.183 175.708 149.098 177.926 150.217ZM183.851 167.362C183.149 169.435 187.552 170.216 187.552 170.216L180.675 169.187C176.778 166.668 180.618 162.177 180.618 162.177C188.878 162.94 190.24 165.081 190.313 165.208C188.771 163.987 184.565 165.291 183.851 167.362Z",
    fill: "url(#paint15_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.906 171.591C155.654 171.922 153.787 172.327 152.068 172.361C151.108 172.382 150.396 171.831 149.875 171.076C152.094 171.206 154.452 171.378 156.906 171.591Z",
    fill: "url(#paint16_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.922 134.381C173.922 134.381 172.797 134.646 170.401 133.707C168.006 132.761 170.504 129.77 170.504 129.77L173.221 130.627C173.221 130.627 170.153 134.391 173.922 134.381ZM199.069 151.385C197.201 151.739 196.75 154.297 196.75 154.297C196.75 154.297 194.497 152.987 194.452 152.781C193.86 150.21 196.965 149.709 196.965 149.709L199.069 151.385ZM195.54 137.888L192.678 139.593C189.166 136.179 191.507 132.142 191.507 132.142L194.982 132.504C193.699 134.466 195.54 137.888 195.54 137.888Z",
    fill: "url(#paint17_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.345 168.383L161.268 167.75C161.268 167.75 159.314 171.255 157.999 171.233C156.685 171.213 156.549 171.144 156.549 171.144L156.345 168.383Z",
    fill: "url(#paint18_linear_1613_30273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.867 127.396C155.859 127.395 155.85 127.394 155.841 127.391C153.17 126.621 152.174 125.039 152.132 124.973C152.086 124.897 152.11 124.798 152.185 124.752C152.261 124.706 152.36 124.729 152.406 124.804C152.416 124.82 153.387 126.35 155.93 127.082C156.015 127.107 156.064 127.196 156.04 127.281C156.018 127.357 155.944 127.405 155.867 127.396ZM153.469 128.528C153.46 128.527 153.452 128.526 153.443 128.523C150.772 127.754 149.775 126.171 149.734 126.104C149.688 126.029 149.711 125.93 149.787 125.883C149.862 125.838 149.961 125.861 150.008 125.936C150.017 125.952 150.989 127.482 153.532 128.214C153.617 128.238 153.666 128.327 153.641 128.412C153.619 128.489 153.546 128.537 153.469 128.528ZM151.466 130.275C151.453 130.273 151.439 130.27 151.426 130.264C151.278 130.206 147.791 128.815 147.176 126.458C147.153 126.372 147.205 126.284 147.29 126.262C147.378 126.238 147.464 126.29 147.487 126.377C148.061 128.576 151.508 129.951 151.543 129.965C151.626 129.998 151.667 130.091 151.634 130.173C151.607 130.243 151.537 130.283 151.466 130.275ZM137.699 156.271C137.677 156.268 137.655 156.261 137.634 156.248L129.929 151.606C129.872 151.572 129.842 151.507 129.853 151.442C129.869 151.35 131.508 142.264 137.635 141.55C137.672 141.545 137.71 141.555 137.741 141.575L144.726 146.133C144.781 146.168 144.808 146.233 144.796 146.297C144.784 146.36 144.735 146.411 144.672 146.425C144.628 146.434 140.287 147.405 138.403 150.54C137.458 152.112 137.28 153.971 137.872 156.067C137.89 156.13 137.868 156.198 137.815 156.238C137.781 156.265 137.74 156.275 137.699 156.271ZM130.191 151.389L137.462 155.769C136.971 153.74 137.195 151.927 138.129 150.374C139.782 147.624 143.131 146.507 144.243 146.202L137.615 141.877C132.125 142.569 130.392 150.377 130.191 151.389Z",
    fill: "#BDC6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.92 146.419C140.898 146.417 140.877 146.41 140.857 146.399L137.141 144.251C137.064 144.206 137.038 144.108 137.082 144.032C137.127 143.954 137.225 143.929 137.302 143.973L141.018 146.121C141.095 146.165 141.121 146.263 141.077 146.34C141.044 146.397 140.981 146.427 140.92 146.419ZM137.557 148.901C137.536 148.899 137.515 148.892 137.495 148.881L133.779 146.731C133.702 146.687 133.675 146.589 133.72 146.512C133.765 146.435 133.862 146.409 133.939 146.454L137.655 148.603C137.732 148.648 137.759 148.746 137.714 148.823C137.681 148.879 137.618 148.908 137.557 148.901ZM135.579 152.949C135.555 152.946 135.531 152.938 135.51 152.924C135.032 152.613 132.039 150.769 132.009 150.75C131.934 150.703 131.91 150.604 131.957 150.529C132.003 150.454 132.103 150.43 132.178 150.477C132.301 150.553 135.204 152.341 135.685 152.655C135.76 152.704 135.781 152.803 135.732 152.878C135.698 152.93 135.637 152.956 135.579 152.949ZM127.716 120.547C127.704 120.545 127.692 120.542 127.68 120.538L123.888 119.162C123.829 119.141 123.788 119.087 123.783 119.025C123.254 113.043 128.003 109.2 128.051 109.162C128.092 109.129 128.148 109.117 128.199 109.134L132.956 110.62C133.019 110.639 133.063 110.695 133.068 110.76C133.073 110.826 133.038 110.888 132.979 110.917C129.119 112.824 127.905 120.335 127.893 120.411C127.886 120.458 127.857 120.5 127.816 120.525C127.787 120.544 127.751 120.55 127.716 120.547ZM124.094 118.896L127.609 120.171C127.819 118.979 129.054 112.857 132.498 110.814L128.187 109.468C127.63 109.943 123.674 113.522 124.094 118.896Z",
    fill: "#BDC6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.872 165.839C181.819 165.717 180.419 165.188 180.351 165.162C180.268 165.13 180.227 165.037 180.259 164.954C180.29 164.872 180.382 164.83 180.466 164.861C180.485 164.869 182.361 165.578 183.334 165.541C183.429 165.537 183.498 165.607 183.501 165.695C183.504 165.783 183.435 165.858 183.347 165.861C183.202 165.867 183.041 165.858 182.872 165.839ZM182.644 168.012C182.633 168.011 182.622 168.009 182.611 168.005L180.352 167.236C180.269 167.208 180.223 167.116 180.252 167.032C180.28 166.948 180.37 166.902 180.456 166.932L182.714 167.7C182.798 167.729 182.843 167.82 182.814 167.904C182.79 167.977 182.718 168.021 182.644 168.012ZM151.725 172.509C148.929 172.187 148.332 167.182 148.307 166.961C148.302 166.916 148.316 166.872 148.345 166.838C148.375 166.804 148.417 166.784 148.462 166.782L156.26 166.533C156.302 166.532 156.345 166.547 156.376 166.577C156.407 166.606 156.425 166.647 156.426 166.69C156.451 167.814 156.752 170.789 157.843 171.051C158.421 171.19 159.525 170.606 161.449 167.022C161.491 166.943 161.589 166.913 161.666 166.956C161.745 166.998 161.774 167.095 161.732 167.173C160.445 169.571 159.372 170.932 158.476 171.293C158.464 171.302 158.45 171.308 158.436 171.313C158.402 171.325 155.002 172.459 152.07 172.524C151.952 172.527 151.837 172.521 151.725 172.509ZM148.65 167.097C148.786 168.015 149.55 172.256 152.063 172.203C154.079 172.158 156.326 171.597 157.506 171.26C156.332 170.602 156.14 167.661 156.11 166.859L148.65 167.097Z",
    fill: "#BDC6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.464 168.598C156.394 168.59 156.335 168.535 156.324 168.462C156.311 168.374 156.371 168.292 156.459 168.279L160.014 167.75C160.1 167.737 160.183 167.797 160.196 167.885C160.209 167.973 160.148 168.055 160.061 168.068L156.506 168.597C156.492 168.599 156.478 168.599 156.464 168.598ZM172.893 134.542C172.3 134.473 171.455 134.291 170.341 133.853C169.748 133.62 169.381 133.246 169.252 132.741C168.917 131.436 170.318 129.734 170.377 129.662C170.42 129.612 170.491 129.593 170.549 129.612L173.266 130.472C173.317 130.488 173.357 130.529 173.372 130.58C173.387 130.63 173.376 130.686 173.343 130.727C172.918 131.249 171.901 132.784 172.291 133.601C172.488 134.015 173.039 134.224 173.92 134.222C173.999 134.22 174.07 134.282 174.08 134.364C174.089 134.445 174.036 134.521 173.957 134.539C173.93 134.545 173.584 134.621 172.893 134.542ZM170.558 129.952C170.289 130.301 169.307 131.666 169.563 132.662C169.667 133.067 169.96 133.359 170.458 133.555C171.189 133.841 171.8 134.015 172.293 134.116C172.167 134.01 172.07 133.885 172 133.739C171.536 132.766 172.558 131.239 172.95 130.71L170.558 129.952ZM196.733 154.456C196.712 154.453 196.69 154.446 196.671 154.435C194.356 153.092 194.31 152.892 194.293 152.816C194.126 152.09 194.224 151.45 194.584 150.914C195.32 149.821 196.875 149.558 196.941 149.548C196.986 149.54 197.031 149.552 197.067 149.581L199.169 151.257C199.218 151.295 199.24 151.36 199.225 151.421C199.21 151.481 199.161 151.528 199.099 151.54C197.364 151.875 196.914 154.3 196.91 154.324C196.901 154.376 196.867 154.42 196.819 154.442C196.792 154.455 196.762 154.459 196.733 154.456ZM194.601 152.723C194.734 152.882 195.7 153.494 196.642 154.046C196.792 153.439 197.32 151.786 198.72 151.309L196.925 149.877C196.626 149.94 195.426 150.238 194.85 151.094C194.546 151.548 194.462 152.097 194.601 152.723ZM192.662 139.752C192.628 139.748 192.595 139.733 192.569 139.707C189.002 136.244 191.341 132.103 191.364 132.062C191.397 132.007 191.457 131.976 191.52 131.983L194.999 132.344C195.056 132.342 195.103 132.384 195.127 132.435C195.152 132.485 195.147 132.545 195.117 132.591C193.901 134.454 195.66 137.777 195.678 137.811C195.719 137.887 195.693 137.981 195.619 138.025L192.763 139.73C192.732 139.749 192.697 139.756 192.662 139.752ZM191.593 132.314C191.273 132.925 189.683 136.362 192.705 139.391L195.325 137.827C195.004 137.181 193.766 134.462 194.718 132.638L191.593 132.314ZM151.206 168.971C151.119 168.961 151.056 168.883 151.065 168.795C151.074 168.707 151.153 168.642 151.241 168.652L154.836 169.026L154.838 169.026C154.925 169.036 154.988 169.114 154.979 169.202C154.97 169.29 154.891 169.355 154.803 169.345L151.208 168.971L151.206 168.971ZM152.79 170.73C151.741 170.609 150.873 170.198 150.814 170.17C150.734 170.131 150.701 170.035 150.739 169.955C150.777 169.876 150.876 169.842 150.953 169.88C150.976 169.891 153.194 170.94 154.725 170.134C154.803 170.094 154.901 170.123 154.942 170.202C154.983 170.281 154.953 170.377 154.875 170.419C154.218 170.765 153.466 170.808 152.79 170.73ZM175.258 149.745C175.228 149.742 175.199 149.729 175.174 149.709C173.289 148.132 172.715 146.095 172.691 146.009C172.668 145.923 172.718 145.835 172.803 145.811C172.888 145.788 172.977 145.838 173 145.924C173.006 145.944 173.576 147.952 175.379 149.462C175.447 149.519 175.456 149.621 175.4 149.688C175.364 149.731 175.31 149.751 175.258 149.745ZM173.006 150.738C172.976 150.735 172.946 150.722 172.921 150.702C171.037 149.124 170.462 147.088 170.438 147.002C170.415 146.916 170.466 146.828 170.551 146.804C170.636 146.782 170.724 146.831 170.748 146.917C170.754 146.937 171.323 148.945 173.127 150.455C173.195 150.512 173.204 150.614 173.147 150.681C173.111 150.724 173.058 150.744 173.006 150.738ZM169.944 151.064C169.914 151.06 169.884 151.048 169.859 151.027C167.975 149.45 167.4 147.414 167.376 147.328C167.353 147.243 167.404 147.154 167.489 147.131C167.574 147.107 167.663 147.157 167.686 147.243C167.692 147.263 168.261 149.271 170.065 150.781C170.133 150.837 170.142 150.939 170.085 151.007C170.049 151.05 169.996 151.07 169.944 151.064ZM187.686 121.989C187.645 121.984 187.606 121.964 187.578 121.929L186.374 120.412L185.17 118.895C185.115 118.825 185.126 118.724 185.196 118.669C185.266 118.614 185.366 118.625 185.421 118.695L187.83 121.729C187.885 121.799 187.873 121.9 187.804 121.955C187.769 121.983 187.726 121.994 187.686 121.989ZM185.345 123.46C185.325 123.458 185.305 123.452 185.286 123.442C183.077 122.233 182.51 119.878 182.487 119.778C182.468 119.692 182.521 119.606 182.608 119.585C182.692 119.565 182.78 119.619 182.8 119.706C182.806 119.728 183.361 122.022 185.44 123.159C185.518 123.202 185.547 123.3 185.504 123.377C185.472 123.437 185.408 123.468 185.345 123.46ZM183.177 125.047C183.166 125.046 183.154 125.043 183.143 125.039C180.766 124.205 179.823 121.975 179.784 121.881C179.75 121.799 179.789 121.705 179.871 121.671C179.953 121.637 180.046 121.676 180.08 121.758C180.089 121.78 181.012 123.951 183.249 124.736C183.333 124.765 183.377 124.857 183.348 124.941C183.322 125.012 183.25 125.055 183.177 125.047ZM206.447 73.9864C206.431 73.9846 206.415 73.9804 206.4 73.9736L204.503 73.1297C204.421 73.0936 204.385 72.9989 204.421 72.9175C204.457 72.8367 204.553 72.8005 204.633 72.8361L206.531 73.68C206.612 73.7161 206.648 73.8108 206.612 73.8922C206.583 73.9581 206.515 73.9942 206.447 73.9864ZM205.281 75.9646C205.261 75.9623 205.241 75.9564 205.222 75.9464L203.124 74.8055C203.046 74.7632 203.017 74.6656 203.06 74.5874C203.102 74.509 203.2 74.4806 203.278 74.5228L205.376 75.6637C205.454 75.706 205.483 75.8035 205.44 75.8818C205.408 75.9409 205.344 75.9719 205.281 75.9646ZM204.848 78.0268C204.828 78.0245 204.808 78.0186 204.79 78.0091L201.621 76.3148C201.543 76.273 201.514 76.1758 201.556 76.0971C201.597 76.0186 201.695 75.9888 201.773 76.031L204.942 77.7253C205.02 77.7671 205.05 77.8643 205.007 77.943C204.976 78.0027 204.912 78.0341 204.848 78.0268ZM200.019 94.3941C199.942 94.3853 199.881 94.3224 199.877 94.2429C199.872 94.1541 199.94 94.0787 200.029 94.0742L203.622 93.8878C203.715 93.8841 203.786 93.9515 203.791 94.0398C203.795 94.1285 203.727 94.2039 203.639 94.2085L200.045 94.3948C200.036 94.3952 200.027 94.3951 200.019 94.3941ZM200.156 96.5999C200.081 96.5913 200.02 96.5307 200.014 96.4533C200.007 96.3647 200.073 96.2873 200.161 96.2804L203.898 95.9798C203.986 95.9732 204.064 96.0385 204.071 96.1267C204.078 96.2153 204.012 96.2927 203.924 96.2996L200.187 96.6003C200.176 96.6013 200.166 96.6011 200.156 96.5999ZM199.844 98.8584C199.767 98.8496 199.706 98.7872 199.702 98.7076C199.696 98.6193 199.764 98.543 199.853 98.5384L203.79 98.313C203.877 98.3092 203.954 98.3758 203.959 98.4642C203.964 98.5525 203.896 98.6288 203.808 98.6334L199.871 98.8588C199.862 98.8601 199.853 98.8595 199.844 98.8584Z",
    fill: "#BDC6DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1613_30273",
    x: 160.559,
    y: 56.8954,
    width: 83.0062,
    height: 64.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1613_30273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1613_30273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1613_30273",
    x1: -114.665,
    y1: 116.4,
    x2: 327.432,
    y2: 360.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1613_30273",
    x1: 103.063,
    y1: 74.3451,
    x2: 103.052,
    y2: 87.0672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1613_30273",
    x1: 107.046,
    y1: 73.5636,
    x2: 112.383,
    y2: 79.4004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1613_30273",
    x1: 92.1656,
    y1: 71.3032,
    x2: 100.577,
    y2: 74.5948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1613_30273",
    x1: 202.063,
    y1: 78.3656,
    x2: 202.046,
    y2: 97.9592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1613_30273",
    x1: 208.196,
    y1: 77.1618,
    x2: 216.415,
    y2: 86.1512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1613_30273",
    x1: 185.279,
    y1: 73.6814,
    x2: 198.233,
    y2: 78.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1613_30273",
    x1: -11.3464,
    y1: 137.067,
    x2: 288.566,
    y2: 299.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1613_30273",
    x1: -45.1862,
    y1: 141.765,
    x2: 238.865,
    y2: 313.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1613_30273",
    x1: 3.05399,
    y1: 137.067,
    x2: 302.966,
    y2: 299.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1613_30273",
    x1: 134.77,
    y1: 117.618,
    x2: 168.503,
    y2: 126.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1613_30273",
    x1: 121.305,
    y1: 135.442,
    x2: 155.716,
    y2: 143.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1613_30273",
    x1: 119.16,
    y1: 104.859,
    x2: 139.516,
    y2: 108.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1613_30273",
    x1: 141.11,
    y1: 163.389,
    x2: 165.213,
    y2: 171.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1613_30273",
    x1: 193.873,
    y1: 66.4651,
    x2: 216.123,
    y2: 71.4928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1613_30273",
    x1: 147.804,
    y1: 60.5521,
    x2: 235.361,
    y2: 74.8649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1613_30273",
    x1: 144.689,
    y1: 169.775,
    x2: 157.213,
    y2: 179.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1613_30273",
    x1: 146.709,
    y1: 120.372,
    x2: 223.399,
    y2: 141.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1613_30273",
    x1: 153.016,
    y1: 165.597,
    x2: 164.8,
    y2: 168.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1613_30273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1613_30273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.863,
    height: 149.835,
    fill: "white",
    transform: "translate(23.7598 30.2402)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/Page Not Found.d03413db9a9002b3db232f3f7c66aeab.svg";
export { ForwardRef as ReactComponent };